import { searchWord } from "../../WordBase";
import { LatinToFixIrregularWord } from "../LatinWord";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const LATIN_TO_FIXES: Array<LatinToFixIrregularWord> = [
  {
    type: "toFixIrregularWord",
    latin: "alius ..., alius ...",
    dutch: "sommige(n) ..., andere(n) ...",
  },
  {
    type: "toFixIrregularWord",
    latin: "aliī ..., aliī",
    dutch: "sommige(n) ..., andere(n) ...",
  },
  {
    type: "toFixIrregularWord",
    latin: "alter ..., alter ...",
    dutch: "de ene ..., de andere ...",
  },
  {
    type: "toFixIrregularWord",
    latin: "hortāri, ~or",
    dutch: "aansporen",
  },
  {
    type: "toFixIrregularWord",
    latin: "verēri, ~eor",
    dutch: "vrezen",
  },
  {
    type: "toFixIrregularWord",
    latin: "loquī, ~or",
    dutch: "spreken",
  },
  {
    type: "toFixIrregularWord",
    latin: "potīrī, ~ior + abl.",
    dutch: "bemachtigen; beheersen",
  },
  {
    type: "toFixIrregularWord",
    latin: "patī, ~ior",
    dutch: "verdragen",
  },
  {
    type: "toFixIrregularWord",
    latin: "cōnārī, ~or",
    dutch: "proberen",
  },
  {
    type: "toFixIrregularWord",
    latin: "mīrārī, ~or",
    dutch: "zich verwonderen over; bewonderen",
  },
  {
    type: "toFixIrregularWord",
    latin: "tuēri, ~eor",
    dutch: "bekijken, beschermen",
  },
  {
    type: "toFixIrregularWord",
    latin: "pollicērī, ~eor",
    dutch: "beloven",
  },
  {
    type: "toFixIrregularWord",
    latin: "fungi, ~or + abl.",
    dutch: "verrichten; uitoefenen",
  },
  {
    type: "toFixIrregularWord",
    latin: "nāscī, ~or",
    dutch: "geboren worden",
  },
  {
    type: "toFixIrregularWord",
    latin: "proficīscī, ~or",
    dutch: "vertrekken",
  },
  {
    type: "toFixIrregularWord",
    latin: "querī, ~or",
    dutch: "klagen over",
  },
  {
    type: "toFixIrregularWord",
    latin: "sequī, ~or",
    dutch: "volgen",
  },
  {
    type: "toFixIrregularWord",
    latin: "ūtī, ~or + abl.",
    dutch: "gebruiken; omgaan met",
  },
  {
    type: "toFixIrregularWord",
    latin: "experīrī, ~iōr",
    dutch: "op de proef stellen; ondervinden",
  },
  {
    type: "toFixIrregularWord",
    latin: "orīrī, ~ior",
    dutch: "ontstaan; opkomen",
  },
  {
    type: "toFixIrregularWord",
    latin: "ēgredī, ~iōr",
    dutch: "buitengaan",
  },
  {
    type: "toFixIrregularWord",
    latin: "morī, ~ior",
    dutch: "sterven",
  },
  {
    type: "toFixIrregularWord",
    latin: "prōgredī, ~ior",
    dutch: "verdergaan",
  },
  {
    type: "toFixIrregularWord",
    latin: "ingredī, ~ior",
    dutch: "binnengaan; beginnen",
  },
  {
    type: "toFixIrregularWord",
    latin: "vidērī, ~eor + dat.",
    dutch: "schijnen",
  },
  {
    type: "toFixIrregularWord",
    latin: "aggredī, ~iōr",
    dutch: "aanvallen",
  },
  {
    type: "toFixIrregularWord",
    latin: "dīgredī, ~ior",
    dutch: "uiteengaan; weggaan",
  },
  {
    type: "toFixIrregularWord",
    latin: "ēgredī, ~ior",
    dutch: "buitengaan",
  },
  {
    type: "toFixIrregularWord",
    latin: "precārī, ~or",
    dutch: "buitengaan",
  },
  // {
  //   type: "toFixIrregularWord",
  //   latin: "",
  //   dutch: "",
  // },
];

export const searchLatinToFixIrregularWord = searchWord(LATIN_TO_FIXES, "Latin to-fix-word", "latin");